import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import styled from "styled-components"
import css from "@styled-system/css"
import { color } from "styled-system"

import ThemeSwitcher from "components/utils/ThemeSwitcher"

import Box from "components/atoms/Box"
import Flex from "components/atoms/Flex"
import { Text } from "components/atoms/Typography"
import StandardPadding from "components/atoms/StandardPadding"
import NavLink from "components/atoms/NavLink"

import FacebookIcon from "images/facebook-icon.svg"
import TwitterIcon from "images/twitter-icon.svg"
import LinkedInIcon from "images/linked-in-icon.svg"

import { colors } from "utils/styled-constants"
import Link from "components/utils/Link"

const StyledFooter = styled("footer")(
  css({
    minHeight: 6,
  }),
  color
)

const StyledSocialLinks = styled("div")`
  a {
    margin-right: 18px;
    &:hover {
      svg {
        opacity: 0.5;
      }
    }
  }
  margin-right: 20px;
  svg {
    transition: opacity 0.1s ease;
  }
`

const SocialLinks = ({ linkedInLink, facebookLink, twitterLink }) => {
  return (
    <StyledSocialLinks>
      {facebookLink && (
        <a href={facebookLink}>
          <FacebookIcon />
        </a>
      )}
      {twitterLink && (
        <a href={twitterLink}>
          <TwitterIcon />
        </a>
      )}
      {linkedInLink && (
        <a href={linkedInLink}>
          <LinkedInIcon />
        </a>
      )}
    </StyledSocialLinks>
  )
}

const FooterMinimal = ({ theme, links, contactInformation }) => {
  return (
    <ThemeSwitcher theme={theme.theme}>
      <StyledFooter bg={`background.${theme.bg}`}>
        <StandardPadding py={0}>
          <Flex
            py={{ _: 6, lg: 5 }}
            minHeight={6}
            flexDirection={{ _: "column", lg: "row" }}
            alignItems={{ _: "flex-start", lg: "center" }}
            justifyContent="space-between"
          >
            <Flex
              flexDirection={{ _: "column-reverse", sm: "row" }}
              flexWrap="nowrap"
            >
              <SocialLinks {...contactInformation} />
              <Flex
                mb={{ _: 6, lg: 0 }}
                flexDirection={{ _: "column", sm: "row" }}
              >
                <NavLink
                  footer
                  variant="footer-link"
                  partiallyActive={true}
                  mb={{ _: 2, sm: 0 }}
                  linkText="Home"
                  internalLink={{ slug: "/" }}
                />
                {links.map((link, i) => (
                  <NavLink
                    footer
                    mb={{ _: 2, sm: 0 }}
                    ml={{ _: 0, sm: 6 }}
                    variant="footer-link"
                    partiallyActive={true}
                    key={i}
                    {...link}
                  />
                ))}
              </Flex>
            </Flex>
            <Flex
              flexDirection="column"
              alignItems={{ _: "flex-start", lg: "flex-end" }}
              mt={{ _: 6, sm: 0 }}
            >
              <Text variant="footer-text">
                ©{new Date().getFullYear()} TechAviv Founder Partners. All
                rights reserved.
              </Text>
              <Text mt={3} color={colors.lighterBlue} variant="footer-text">
                Designed by{" "}
                <a
                  href="https://www.westonbaker.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  style={{ color: "inherit" }}
                >
                  Weston Baker Creative Group
                </a>
              </Text>
            </Flex>
          </Flex>
        </StandardPadding>
      </StyledFooter>
    </ThemeSwitcher>
  )
}

export default FooterMinimal

FooterMinimal.defaultProps = {
  theme: { theme: "default", bg: 0 },
}

FooterMinimal.propTypes = {
  theme: PropTypes.shape({
    theme: PropTypes.string,
    bg: PropTypes.number,
  }),
  links: PropTypes.arrayOf(PropTypes.shape(Link.strapiProps)),
  copyrightText: PropTypes.string,
}
